module.exports = __webpack_public_path__ + "static/img/frozen-phase-1.a8a8fe2.png";